import { HTMLAttributes, ReactNode, forwardRef } from 'react'
import classNames from 'classnames/bind'

import styles from './controls-bar.module.scss'

const cx = classNames.bind(styles)

export type ControlsBarProps = {
  left?: boolean
  right?: boolean
  middle?: boolean
  top?: boolean
  bottom?: boolean
  spaceBetween?: boolean
  disableShrinkItems?: boolean
  className?: string
  nowrap?: boolean
  fillPrimary?: boolean
  children?: ReactNode
} & HTMLAttributes<HTMLDivElement>

const ControlsBar = forwardRef<HTMLDivElement, ControlsBarProps>(
  (
    {
      left,
      right,
      middle,
      top,
      bottom,
      spaceBetween,
      disableShrinkItems,
      className,
      nowrap,
      fillPrimary,
      children,
      ...other
    },
    ref,
  ) => {
    const classes = cx(
      styles.root,
      {
        left: left || (!right && !middle),
        right,
        middle,
        top,
        bottom,
        spaceBetween,
        disableShrinkItems,
        nowrap,
        fillPrimary,
      },
      className,
    )

    return (
      <div className={classes} ref={ref} {...other}>
        {children}
      </div>
    )
  },
)

export default ControlsBar
